<template>
  <div>
          <div class="mt-2" v-if=" msgErro.length > 0">
              <v-alert type="error" dense class="subtitle-2 font-weight-regular">
                  <div class="p-1" v-if="msgErro.length > 0">
                      <div  v-for="erro in msgErro" :key="erro">
                          <span v-html="erro"></span> 
                      </div>
                  </div>
                  <div v-else>>
                      {{ msgErro }}
                  </div>
              </v-alert>
          </div>
          <div>
              <v-snackbar
                  v-model="snackbar"
                  :app="true"
                  left
                  :timeout="5000"
                  color="#198754"
              >
                  <div class="p-1" v-if="msg.length > 0">
                      <div  v-for="msg in msg" :key="msg">
                          <span v-html="msg"></span> 
                      </div>
                  </div>
                  <div v-else>>
                      {{ msg }}
                  </div>
              </v-snackbar>
          </div>
          <div class="mt-4">
              <div class="row">
                  <div class="col-sm-12 col-md-2">
                      <v-text-field 
                        type="text"
                        class="filled-error"
                        label="Ano letivo*" 
                        filled 
                        :error=" ($v.aaletivo.required === false ) && $v.$dirty === true ? true : false"
                        :error-messages=" ($v.aaletivo.required === false ) && $v.$dirty === true ? messages.required : ($v.aaletivo.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
                        background-color="white"
                        min ="4"
                        :maxlength="4"
                        v-mask="'####'"
                        id="aaletivo" 
                        hide-details="auto"
                        v-model.number="aaletivo"
                      >
                      </v-text-field>
                  </div>
              </div>
          </div>
          <div class="mt-4 row">
              <div class="col-sm-12 col-md-3">
                <v-text-field 
                    type="date"
                    v-model="diaParaCancelar"
                    class="filled-error"
                    label="Dia a ser cancelado*" 
                    filled 
                    :error=" ($v.diaParaCancelar.required === false ) && $v.$dirty === true ? true : false"
                    :error-messages=" ($v.diaParaCancelar.required === false ) && $v.$dirty === true ? messages.required : ($v.diaParaCancelar.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
                    background-color="white"
                    min ="10"
                    :maxlength="10"
                    id="diacancelado" 
                    hide-details="auto"
                >
                </v-text-field>
              </div>
              <div class="col-sm-12 col-md-3">
                  <v-text-field 
                    type="number"
                    v-model.number="numeroDiasUteisAdiamento"
                    class="filled-error"
                    label="Número de dias úteis de adiamento da efetivação*" 
                    filled 
                    :error=" ($v.numeroDiasUteisAdiamento.required === false ) && $v.$dirty === true ? true : false"
                    :error-messages=" ($v.numeroDiasUteisAdiamento.required === false ) && $v.$dirty === true ? messages.required : ($v.numeroDiasUteisAdiamento.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
                    background-color="white"
                    min ="1"
                    max = "365"
                    :maxlength="3"
                    id="motivo" 
                    hide-details="auto"
                  >
                </v-text-field>
              </div>
          </div>
          <div class="mt-4 row">
            <div class="col-sm-12 col-md-6">
                <v-textarea
                    v-model="motivoDoCancelamento"
                    background-color="white"
                    filled
                    label="Motivo do cancelamento*"
                    auto-grow
                    :error=" ($v.motivoDoCancelamento.required === false ) && $v.$dirty === true ? true : false"
                    :error-messages=" ($v.motivoDoCancelamento.required === false ) && $v.$dirty === true ? messages.required : ($v.motivoDoCancelamento.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
                ></v-textarea>
            </div>
          </div>
          <div class="d-flex">
            <span>
                <v-btn depressed color="primary" @click="previaRanking" :disabled=" reload || desativaBotaoGerarRanking "> Prévia do Ranking </v-btn>
            </span>
            <span class="ml-4">
                <v-btn depressed color="success" @click="atualizarRanking" :disabled="reload || desativarBotaoAtualizarRanking "> Atualizar Ranking  </v-btn>
            </span>
           
              <div class="text-center d-flex ml-auto" v-if="listaDoRanking.length > 0 && !reload">
                
                <v-menu offset-x :close-on-content-click="false" >
                  <template v-slot:activator="{ on, attrs }" >
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span >
                        <v-icon small>fas fa-filter</v-icon>
                      </span>
                    </v-btn>
                  </template>
                  <v-list class="p-2" style="background-color: rgb(250,250,250);">
                      <v-list-item>
                        <v-list-item-title>
                          <v-text-field  
                              filled 
                              background-color="white"
                              label="Matrícula"
                              v-mask="'m######'"  
                              id="matricula" 
                                v-debounce:1s="filtrarRanking"
                              v-model="filtro.matricula" clearable placeholder="m999999"
                              @focus="filtro.nomeCompleto = ''; filtro.especialidade = ''; filtro.agendamento = ''"
                          ></v-text-field>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-text-field    
                            id="nomecompleto" 
                            filled 
                            label="Nome completo"
                            background-color="white"
                            v-model="filtro.nomeCompleto" 
                            v-debounce:1s="filtrarRanking"
                            @focus="filtro.matricula = ''; filtro.especialidade = ''; filtro.agendamento = ''"
                            clearable @input=" (filtro.nomeCompleto) ? filtro.nomeCompleto = filtro.nomeCompleto.toUpperCase() : ''">

                          </v-text-field>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-text-field    id="especialidade" 
                          filled 
                          background-color="white"
                          label="Especialidade"
                          v-debounce:1s="filtrarRanking"
                          v-model="filtro.especialidade" clearable 
                          @focus="filtro.nomeCompleto = ''; filtro.matricula = ''; filtro.agendamento = ''"
                          @input="(filtro.especialidade) ? filtro.especialidade = filtro.especialidade.toUpperCase() : ''">

                          </v-text-field>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <v-text-field    id="agendamento" v-mask="'##/##/#### ##:##'"
                            filled 
                           background-color="white"
                           label="Agendamento da Efetivação"
                           placeholder="99/99/9999 99:99"
                          @focus="filtro.nomeCompleto = ''; filtro.especialidade = ''; filtro.matricula = ''"
                          v-debounce:1s="filtrarRanking"
                           v-model="filtro.agendamento" clearable @input=" (filtro.agendamento) ? filtro.agendamento = filtro.agendamento.toUpperCase() : '' ">
                          </v-text-field>
                        </v-list-item-title>
                      </v-list-item>
                     
                  </v-list>
                 
                </v-menu>
              </div>
          </div>
          <div class="p-2 mt-4 text-center" v-if="reload">
              <v-progress-circular
                :size="100"
                color="primary"
                indeterminate
              ></v-progress-circular>
          </div>
          <div class="row p-2 mt-2" v-else >
            <template>
              <v-tabs
                fixed-tabs
                light
              >
              <v-tabs-slider color="blue darken-1"></v-tabs-slider>
                <v-tab >
                  Ranking
                </v-tab>
                <v-tab >
                  Efetivações do dia que serão canceladas
                </v-tab>
                  <v-tab-item >
                    <v-card flat>
                      <v-card-text>

                          <v-data-table
                            fixed-header
                            no-data-text="Nenhum dado encontrado"
                            loading-text="Aguarde..."
                            :headers="[
                                        {text: 'Matrícula', value: 'matricula'}, 
                                        {text: 'Nome completo', value: 'nmfuncion'}, 
                                        {text: 'Cargo', value: 'dscargo'}, 
                                        {text: 'Especialidade', value: 'dsespecia'}, 
                                        {text: 'Tipo de Distribuição', value: 'dstpcargo'}, 
                                        {text: 'Agendamento Anterior', value: 'agendamento'},
                                        {text: 'Novo Agendamento', value: 'novoagendamento'}
                                      ]"
                            class="elevation-1"
                            v-if="rankingFiltrado.length === 0"
                            :items-per-page="10"
                            :items="listaDoRanking"
                            :footer-props="{
                              'items-per-page-text':'Itens por página',
                              'items-per-page-all-text':  'Todos',
                            }"
                          >
                            <template slot="items" slot-scope="item">
                                  <td>{{item.matricula}}</td>
                                  <td>{{item.nmfuncion}}</td>
                                  <td>{{item.dsespecia}}</td>
                                  <td>{{item.tsacessoin}}</td>
                                  <td>{{item.novoagendamento}}</td>
                            </template>
                            <template v-slot:[`footer.page-text`]="items"> 
                              {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template>
                            
                          </v-data-table>

                          <v-data-table
                            fixed-header
                            no-data-text="Nenhum dado encontrado"
                            loading-text="Aguarde..."
                            :headers="[{text: 'Ordem', value: 'index'}, {text: 'Matrícula', value: 'matricula'}, {text: 'Nome completo', value: 'nmfuncion'}, 
                                  {text: 'Justificativa', value: 'dsjustifi'}, {text: 'Especialidade', value: 'dsespecia'}, 
                                  {text: 'Situação funcional', value: 'dsafastam'}, {text: 'Agendamento da Efetivação das aulas', value: 'horario'}]"
                            class="elevation-1"
                            v-if="rankingFiltrado.length > 0"
                            :items-per-page="10"
                            :items="rankingFiltrado"
                            :footer-props="{
                              'items-per-page-text':'Itens por página',
                              'items-per-page-all-text':  'Todos',
                            }"
                          >
                            <template slot="items" slot-scope="item">
                                  <td>{{item.id}}</td>
                                  <td>{{item.matricula}}</td>
                                  <td>{{item.nmfuncion}}</td>
                                  <td>{{item.dsjustifi}}</td>
                                  <td>{{item.dsespecia}}</td>
                                  <td>{{item.dsafastam}}</td>
                                  <td>{{item.tsacessoin}}</td>
                            </template>
                            <template v-slot:[`footer.page-text`]="items"> 
                              {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template>
                            
                          </v-data-table>
                      </v-card-text>
                    </v-card>
                    


                  </v-tab-item>
                  <v-tab-item >
                    <v-card flat>
                       <v-card-text>
                         <v-data-table
                            fixed-header
                            no-data-text="Nenhum dado encontrado"
                            loading-text="Aguarde..."
                            :headers="[
                                        {text: 'Matrícula', value: 'matricula'}, 
                                        {text: 'Nome completo', value: 'nmfuncion'}, 
                                        {text: 'Cargo', value: 'dscargo'}, 
                                        {text: 'Especialidade', value: 'dsespecia'}, 
                                        {text: 'Tipo de Distribuição', value: 'dstpcargo'}, 
                                        {text: 'Escola', value: 'nmescola'},
                                        {text: 'Disciplina', value: 'dsdiscipl'},
                                        {text: 'Turno', value: 'cnperiodo'},
                                        {text: 'Etapa Escolar', value: 'dsserie'},
                                        {text: 'Qtd Aulas', value: 'qtdaulas'}
                                      ]"
                            class="elevation-1"
                            v-if="aulasEfetivadasNoDiaFiltrado.length === 0"
                            :items-per-page="10"
                            :items="aulasEfetivadasNoDia"
                            :footer-props="{
                              'items-per-page-text':'Itens por página',
                              'items-per-page-all-text':  'Todos',
                            }"
                          >
                            <template slot="items" slot-scope="item">
                                  <td>{{item.matricula}}</td>
                                  <td>{{item.nmfuncion}}</td>
                                  <td>{{item.dscargo}}</td>
                                  <td>{{item.dsespecia}}</td>
                                  <td>{{item.nmescola}}</td>
                                  <td>{{item.dsdiscipl}}</td>
                                  <td>{{item.cnperiodo}}</td>
                                  <td>{{item.dsserie}}</td>
                                  <td>{{item.qtdaulas}}</td>
                            </template>
                            <template v-slot:[`footer.page-text`]="items"> 
                              {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template>
                            
                          </v-data-table>

                          <v-data-table
                            fixed-header
                            no-data-text="Nenhum dado encontrado"
                            loading-text="Aguarde..."
                            :headers="[
                                        {text: 'Matrícula', value: 'matricula'}, 
                                        {text: 'Nome completo', value: 'nmfuncion'}, 
                                        {text: 'Cargo', value: 'dscargo'}, 
                                        {text: 'Especialidade', value: 'dsespecia'}, 
                                        {text: 'Tipo de Distribuição', value: 'dstpcargo'}, 
                                        {text: 'Escola', value: 'nmescola'},
                                        {text: 'Disciplina', value: 'dsdiscipl'},
                                        {text: 'Turno', value: 'cnperiodo'},
                                        {text: 'Etapa Escolar', value: 'dsserie'},
                                        {text: 'Qtd Aulas', value: 'qtdaulas'}
                                      ]"
                            class="elevation-1"
                            v-if="aulasEfetivadasNoDiaFiltrado.length > 0"
                            :items-per-page="10"
                            :items="aulasEfetivadasNoDiaFiltrado"
                            :footer-props="{
                              'items-per-page-text':'Itens por página',
                              'items-per-page-all-text':  'Todos',
                            }"
                          >
                            <template slot="items" slot-scope="item">
                                  <td>{{item.matricula}}</td>
                                  <td>{{item.nmfuncion}}</td>
                                  <td>{{item.dscargo}}</td>
                                  <td>{{item.dsespecia}}</td>
                                  <td>{{item.nmescola}}</td>
                                  <td>{{item.dsdiscipl}}</td>
                                  <td>{{item.cnperiodo}}</td>
                                  <td>{{item.dsserie}}</td>
                                  <td>{{item.qtdaulas}}</td>
                            </template>
                            <template v-slot:[`footer.page-text`]="items"> 
                              {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                            </template>
                            
                          </v-data-table>


                       </v-card-text>
                    </v-card>


                  </v-tab-item>
                
              </v-tabs>
            </template>

          </div>
      
  </div>
</template>

<script>
import Buscar from '../../components/Buscar.vue'
import { mask } from "vue-the-mask"
import filaAcesso from '../../api/filaAcesso'
import { required, minLength } from 'vuelidate/lib/validators'
import  messages  from '../../utils/messages'
import { mapGetters } from 'vuex'


export default {
    name: 'Ranking',
    directives: { mask },
    components: {
        Buscar,
    },

    data() {
      return {
        msgErro: [],
        msg: [],
        aaletivo: '',
        diaParaCancelar: '',
        aulasEfetivadasNoDia: [],
        aulasEfetivadasNoDiaFiltrado: [],
        numeroDiasUteisAdiamento: 1,
        motivoDoCancelamento: '',
        snackbar: false,
        desativaBotaoGerarRanking: false,
        desativarBotaoAtualizarRanking: true,
        tpcargo: '',
        listaDoRanking: [],
        reload: false,
        filtro: {
          matricula: '',
          nomeCompleto: '',
          especialidade: '',
          agendamento: '',

        },
        messages: messages,
        rankingFiltrado: [],
        datasDesconsideradas: [],
      }
    },
    created() {
      this.aaletivo = this.getAnoLetivo
    },
    watch: {
      aaletivo: function(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.iniciarFormulario()
        }
      },
      diaParaCancelar: function(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.iniciarFormulario()
        }
      },
      numeroDiasUteisAdiamento: function(newValue, oldValue) {
        if(newValue !== oldValue) {
          this.iniciarFormulario()
        }
      }
      
    },
    validations: {
      aaletivo: {required, minLength: minLength(4)},
      diaParaCancelar: {required},
      numeroDiasUteisAdiamento: {required},
      motivoDoCancelamento: {required},
    },
    computed: {
      ...mapGetters(['getAnoLetivo', 'getCdLogin']),
    },
    methods: {

      iniciarFormulario() {
          this.desativaBotaoGerarRanking = false
          this.desativarBotaoAtualizarRanking = true
          this.listaDoRanking = []
          this.rankingFiltrado = []
          this.aulasEfetivadasNoDia = []
          this.aulasEfetivadasNoDiaFiltrado = []

      },
      consistirFormulario() {
        this.msgErro = []
        this.msg = []
        this.reload = true
        let erro = false

        this.$v.$touch()

        if (this.$v.$invalid) {
            this.msgErro = ['Preencha os campos corretamente']
            this.reload = false;
            erro = true
            
        }
        return erro;

      },

      async previaRanking() {

        if(this.consistirFormulario()){
          this.desativaBotaoGerarRanking = false
          return
        };
       

        try {
                this.reload = true
                const {data} = await filaAcesso.adiarRanking( {
                                                                  aaletivo: this.aaletivo, 
                                                                  data: this.diaParaCancelar,
                                                                  adiamento: this.numeroDiasUteisAdiamento,
                                                                  
                                                              }
                                                            )

              this.listaDoRanking = data.ranking
              this.tpcargo = data.tpcargo
              this.aulasEfetivadasNoDia = data.aulasEfetivadasDoDia
              this.reload = false
              this.desativaBotaoGerarRanking = true
              this.desativarBotaoAtualizarRanking = false

        }
        catch(erro) {
          this.reload = false
          this.desativaBotaoGerarRanking = false
          this.msgErro = erro.response.data.mensagem
          this.desativarBotaoAtualizarRanking = true
        }

      },
      
      async atualizarRanking() {
        if(this.consistirFormulario()) {
          this.desativarBotaoAtualizarRanking = false
          return
        };
        
        try {
          this.reload = true
          this.desativarBotaoAtualizarRanking = true
          const novoRaking = this.listaDoRanking.map( (element) => {
                                                                        return {
                                                                          aaletivo: element.aaletivo,
                                                                          cdpessoal: parseInt(element.cdpessoal),
                                                                          cdmatric: element.cdmatric,
                                                                          tpcargo: element.tpcargo,
                                                                          aatcargo: element.aatcargo,
                                                                          mmtcargo: element. mmtcargo,
                                                                          cdgcargo: element.cdgcargo,
                                                                          cdcargo: element.cdcargo,
                                                                          tpcargo: element.tpcargo,
                                                                          cdespecia: element.cdespecia,
                                                                          tsacessoin: element.novotsacessoin,
                                                                          tsacessofin: element.novotsacessofin,
                                                                        }
                                                                    })
          const {data} = await filaAcesso.cancelarEfetivacoesDoDia({
                                                                      ranking: novoRaking,
                                                                      aaletivo: this.aaletivo,
                                                                      tpcargo: this.tpcargo,
                                                                      data: this.diaParaCancelar,
                                                                      dtproblem: this.diaParaCancelar,
                                                                      nudiasad: this.numeroDiasUteisAdiamento,
                                                                      dsmotivo: this.motivoDoCancelamento,
                                                                      cdmatatual: this.getCdLogin,

                                                                  })
          this.reload = false
          this.msg = data.mensagem
          this.snackbar = true
          this.desativaBotaoGerarRanking = false
          
          
        }
        catch(erro) {
              this.reload = false
              this.msgErro = erro
              this.desativaBotaoGerarRanking = true
              this.desativarBotaoAtualizarRanking = false
              
        }

      },
      
      filtrarRanking() {
        if(this.filtro.matricula) {
           this.rankingFiltrado = this.listaDoRanking.filter(e => e.matricula.includes( this.filtro.matricula) )
           this.aulasEfetivadasNoDiaFiltrado = this.aulasEfetivadasNoDia.filter(e => e.matricula.includes( this.filtro.matricula) )
         }
         else if(this.filtro.nomeCompleto) {
           this.rankingFiltrado = this.listaDoRanking.filter(e => e.nmfuncion.includes( this.filtro.nomeCompleto) )
           this.aulasEfetivadasNoDiaFiltrado = this.aulasEfetivadasNoDia.filter(e => e.nmfuncion.includes( this.filtro.nomeCompleto) )
         }
         else if(this.filtro.especialidade) {
           this.rankingFiltrado = this.listaDoRanking.filter(e => e.dsespecia.includes( this.filtro.especialidade) )
           this.aulasEfetivadasNoDiaFiltrado = this.aulasEfetivadasNoDia.filter(e => e.dsespecia.includes( this.filtro.especialidade) )
         }
         else if(this.filtro.agendamento) {
           this.rankingFiltrado = this.listaDoRanking.filter(e => e.horario.includes( this.filtro.agendamento) )
         }
         else {
           this.rankingFiltrado = []
           this.aulasEfetivadasNoDiaFiltrado = []
         }
        
      }
    }
}
</script>

<style>




</style>